export const initialState = {
  noteData: {
    loading: false,
    error: '',
    data: null,
  },
  thankYouData: {
    loading: false,
    error: '',
    data: {
      note: '',
      account: null,
    },
  },
};
